/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Create_FolderInputs */

const en_dialog_create_folder = /** @type {(inputs: Dialog_Create_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a new folder`)
};

const es_dialog_create_folder = /** @type {(inputs: Dialog_Create_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear una nueva carpeta`)
};

/**
* | output |
* | --- |
* | "Create a new folder" |
*
* @param {Dialog_Create_FolderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_create_folder = /** @type {((inputs?: Dialog_Create_FolderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Create_FolderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_create_folder(inputs)
	return en_dialog_create_folder(inputs)
});